import type { ReadonlyDeep } from 'type-fest';

import { invariant } from '@e-socna/utils';
import { FolderArchiveInfoInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { FolderStateForm_FolderArchiveInfo } from '../fragments/folder-archive-info.fragment';

export function folderArchiveInfoForm2ApiMapper(
  draft: Readonly<FolderStateForm_FolderArchiveInfo>,
): ReadonlyDeep<FolderArchiveInfoInput> {
  invariant(
    !!draft.startDateForAnalytics,
    'Start date for analytics is missing',
  );
  invariant(!!draft.endDateForAnalytics, 'End date for analytics is missing');
  invariant(
    draft.startDateForAnalytics <= draft.endDateForAnalytics,
    'Start date for analytics must be before or equal to the end date',
  );

  return pruneInput(draft, FolderArchiveInfoInput);
}
